import { serviceName } from '../resources/serviceConstants';
import {
  FETCH_USER_INFO,
  FETCH_USER_PROFILE_PICTURE,
  HIRING_DETAILS,
  TRIGGER_EFFORT_UPLOAD,
  TRIGGER_LEAVE_SYNC,
  TRIGGER_LEAVE_UPLOAD,
} from '../resources/endPoint';

export const fetchUserInfo = (data) => {
  return {
    url: FETCH_USER_INFO,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.INTEGRATION_MS,
  };
};

export const fetchUserProfilePicture = (data) => {
  return {
    url: FETCH_USER_PROFILE_PICTURE,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.INTEGRATION_MS,
  };
};

export const fetchHiringDetails = (fromDate, toDate, emailId, mobile) => {
  return {
    url: `${HIRING_DETAILS}?fromJoiningDate=${fromDate}&toJoiningDate=${toDate}&emailId=${emailId}&phoneNo=${mobile}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.INTEGRATION_MS,
  };
};
export const triggerEffortUpload = (data) => {
  return {
    url: TRIGGER_EFFORT_UPLOAD,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.INTEGRATION_MS,
  };
};

export const triggerLeaveUpload = (data) => {
  return {
    url: TRIGGER_LEAVE_UPLOAD,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.INTEGRATION_MS,
  };
};

export const triggerSyncLeaveData = (data) => {
  return {
    url: TRIGGER_LEAVE_SYNC,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.INTEGRATION_MS,
    timeout: 900000, // 15 minutes
  };
};
